fragment GalleryFragment on gallery_Entry {
  typeHandle
  slides: gallerySlides {
    ... on gallerySlidesBlock_Entry {
      id
      image {
        ...CraftAssetFragment
      }
      alt
      caption
    }
  }
}
